import { FolderOpenDot } from 'lucide-react'
import { useState } from 'react'

import FilterManagementDropdown from 'components/brokers/needs_attention/FilterManagementDropdown'
import { filterByLabelAndValueCallback } from 'components/brokers/needs_attention/utils'
import { type MultipleSelectedValuesFilter } from 'components/brokers/types'
import ComboboxMultiSelectFilter, {
  type ComboboxFilterOption,
} from 'components/reusable/table/ComboboxMultiSelectFilter'

const SubstantiationMedicalCareFilter = (props: MultipleSelectedValuesFilter) => {
  const [query, setQuery] = useState('')

  const medicalCareOptions: ComboboxFilterOption<string>[] = [
    { label: 'Receipt', value: 'receipt' },
    { label: 'Recurring Transaction', value: 'recurring_transaction' },
    { label: 'Manual', value: 'medical_care_manual' },
    { label: 'Enrollment', value: 'enrollment' },
  ]

  const filteredOptions = medicalCareOptions?.filter(
    filterByLabelAndValueCallback(query)
  )

  return (
    <div>
      <ComboboxMultiSelectFilter
        {...props}
        options={[{ groupLabel: 'Medical Care', options: filteredOptions || [] }]}
        placeholder='Search medical care types to filter...'
        onValueChange={setQuery}
      >
        <FilterManagementDropdown
          {...props}
          options={medicalCareOptions || []}
          noSelectionText='Medical Care'
          pluralIdentifier='medical care types'
        >
          <FolderOpenDot size={20} />
        </FilterManagementDropdown>
      </ComboboxMultiSelectFilter>
    </div>
  )
}

export default SubstantiationMedicalCareFilter
